import { SxProps, Theme } from '@mui/material';

export const contactBoxIconsStylesSx: SxProps<Theme> = (theme) => ({
	display: 'flex',
	justifyContent: 'space-between',
	[theme.breakpoints.down('md')]: {
		flexDirection: 'column',
		alignItems: 'baseline',
		gap: '15px',
		marginTop: '15px',
		paddingLeft: '15px',
	},
});
